import React, { useMemo, useState } from 'react'

import { connect } from 'react-redux'
import { isFunction, isObject, snakeCase, values } from 'lodash'
import { Divider, message, notification } from 'antd'

import { isValid } from '../../../utils/validators'
import FormFooter from '../../../Components/antd/Forms/FormFooter'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import InternshipForm from './InternshipForm'
import { Internship } from '../../../utils/entities/internship'

export const BODY_STYLE = { display: 'flex', flexDirection: 'column', height: '93%', width: '100%' }
export const SELECT_STYLE = { width: '200px' }

message.config({
  top: 20,
  duration: 3,
  maxCount: 1,
  placement: 'topRight'
})

const mapStateToProps = state => ({ t: selectTranslate(state) })

const SingleInternshipForm = ({ data, disabled, sectors = [], validators, onDelete, onSubmit, onCancel, t }) => {
  const [formData, setFormData] = useState(isObject(data) ? new Internship(data) : data)
  const [errorFields, setErrorFields] = useState([])

  const handleSubmit = event => {
    const errors = isValid(formData, values(validators))
    setErrorFields(errors.keys)

    if (errors.keys.length > 0) {
      const errorMessages = t('common_form.error_fields', {
        fields: errors.keys.map(key => t('common.' + snakeCase(key))).join(', ')
      })

      notification.error({ message: errorMessages })
    } else if (formData.startDate > formData.endDate) {
      message.error({ message: t('common_form.error_dates') })
    } else {
      onSubmit(new Internship(formData))
    }
  }

  const updateInternship = newData => setFormData(form => ({ ...form, ...newData }))

  const isSubmitDisabled = useMemo(() => (
    formData.startDate === null || formData.endDate === null || formData.sector === null || formData.section === null || disabled
  ), [formData.startDate, formData.endDate, formData.sector, formData.section, disabled])

  const submitButtonProps = useMemo(() => ({
    text: t('modal.ok_button.save'),
    disabled: isSubmitDisabled,
    title: isSubmitDisabled && t('form_modal.add_button.disabled_tooltip', {
      fields: [
        t('common.period'),
        t('common.sector'),
        t('common.school'),
        t('common.section')
      ].join(', ')
    })
  }), [isSubmitDisabled, t])

  return (
    <div>
      <div className='w-100 pd-12'>
        <InternshipForm
          data={formData}
          disabled={disabled}
          sectors={sectors}
          errorFields={errorFields}
          onChange={updateInternship}
        />
      </div>

      <Divider className='divider-4' />

      <FormFooter
        cancel={{ text: t('modal.cancel_button'), disabled }}
        remove={formData.id > 0 && { popover: { content: t('internship_form_footer.popover.delete'), title: t('common.delete') } }}
        submit={submitButtonProps}
        onCancel={onCancel}
        onDelete={isFunction(onDelete) ? onDelete : null}
        onSubmit={handleSubmit}
      />
    </div>
  )
}

export default connect(mapStateToProps)(SingleInternshipForm)
